
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    name: 'HomeDiscounts',
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        products: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            swiperOptions: {
                // Swiper 5 otherwise bypasses loading="lazy" with eager Image requests.
                preloadImages: false,
                slidesPerView: 'auto',
                spaceBetween: 5,
                watchOverflow: true,
                scrollbar: {
                    el: '.home-discounts__scrollbar',
                    draggable: true,
                    dragSize: 56,
                    hide: false,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 5,
                        scrollbar: {dragSize: 'auto'},
                    },
                },
                on: {
                    breakpoint(params) {
                        // Swiper 5 retains desktop widths when returning to auto sizing.
                        if (params.slidesPerView === 'auto' && this.slides) {
                            this.slides.each((index, slide) => {slide.style.width = '';});
                        }
                    },
                },
            },
        }
    },
    computed: {
        currency() {
            return this.$config.siteCountry === 'kz' ? '₸' : '₽';
        },
        productCards() {
            return this.products
                .filter(product => this.hasActiveDiscount(product))
                .map((product) => {
                    const nameParts = this.splitName(product.name);
                    const price = Number(product.price);
                    const priceBase = Number(product.price_base);

                    return {
                        ...product,
                        title: nameParts.title,
                        variant: nameParts.variant,
                        price,
                        priceBase,
                        discount: Math.round((1 - price / priceBase) * 100),
                        image: this.getImage(product, 'small'),
                        image2x: this.getImage(product, 'medium'),
                    };
                });
        },
    },
    methods: {
        hasActiveDiscount(product) {
            const price = Number(product.price);
            const priceBase = Number(product.price_base);

            return price > 0 && priceBase > 0 && price < priceBase;
        },
        splitName(name = '') {
            const parts = name.split(/\s+-\s+/);
            const title = parts.shift() || name;
            const variant = parts.join(' - ').replace(/\s+размер\s+.*$/i, '');

            return {title, variant};
        },
        getImage(product, size) {
            if (!product.image) {
                return '/assets/no_image.jpg';
            }

            return (product.image.sizes && product.image.sizes[size])
                || product.image.path
                || '/assets/no_image.jpg';
        },
        formatPrice(price) {
            return new Intl.NumberFormat('ru-RU').format(price);
        },
        slidePrev() {
            if (this.$refs.discountsSwiper && this.$refs.discountsSwiper.$swiper) {
                this.$refs.discountsSwiper.$swiper.slidePrev();
            }
        },
        slideNext() {
            if (this.$refs.discountsSwiper && this.$refs.discountsSwiper.$swiper) {
                this.$refs.discountsSwiper.$swiper.slideNext();
            }
        },
    },
}
